// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Reports__View[data-v-c6c0494c] {\n  height: 100%;\n}\n.Reports__View .link-button[data-v-c6c0494c] {\n    background: #00427e;\n    border: none;\n    border-radius: 3px;\n    padding: 14px 25px;\n    margin-left: 10px;\n    color: white;\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
